import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupComponent } from '../components/popup/popup.component';



@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule
  ],
  entryComponents: [
    PopupComponent
  ]
})
export class PopupModule { }
